module.exports = __webpack_public_path__ + "img/live_bg.23b0b17.png";